const buildGet = (baseURL) => {
  return async (additionalSearchParams) => {
    let base = new URL(baseURL, window.location);
    let currentSearchParams = new URLSearchParams(window.location.search);
    currentSearchParams.forEach((value, key) => {
      base.searchParams.set(key, value);
    });

    additionalSearchParams.forEach((value, key) => {
      base.searchParams.set(key, value);
    });

    const request = new Request(`${base.pathname}${base.search}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "text/plain",
        "X-Requested-With": "XMLHttpRequest",
      }),
    });

    const res = await fetch(request)
      .then((res) => res.text())
      .catch(() => {});

    return res;
  };
};

const buildPost = (baseURL, csrftoken) => {
  return async ({ additionalSearchParams = [], body = {} }) => {
    let base = new URL(baseURL, window.location);
    additionalSearchParams.forEach((value, key) => {
      base.searchParams.set(key, value);
    });

    const request = new Request(`${base.pathname}${base.search}`, {
      method: "POST",
      type: "POST",
      processData: false,
      headers: new Headers({
        "X-CSRF-Token": csrftoken,
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      }),
      body: JSON.stringify(body),
    });

    return fetch(request)
      .then((res) => res.text())
      .catch(() => {});
  };
};

export { buildGet, buildPost };
